import { AppProviders, configureAppErrorReporting, TenantProvider } from "@how/app-kit";
import { RouterProvider } from "react-router";
import { env } from "../lib/env";
import { queryClient } from "../lib/query-client";
import { supabase } from "../lib/supabase";
import { createAppRouter } from "./router";

// This app's one error destination (ADR 0038), set before the first render so an early failure is reported too.
configureAppErrorReporting({
  surface: "member_portal",
  supabaseUrl: env.VITE_SUPABASE_URL,
  client: supabase,
});

const router = createAppRouter();

/** Provider stack from @how/app-kit, the tenant resolved from the hostname, and this app's router. */
export function App() {
  return (
    <AppProviders client={supabase} queryClient={queryClient}>
      <TenantProvider env={env} surface="member_portal">
        <RouterProvider router={router} />
      </TenantProvider>
    </AppProviders>
  );
}
